// Pricing
export const CHECKOUT_BUTTON_CLICKED = "Checkout button clicked"
export const CONTACT_US_FOR_BUSINESS = "Contact us for business"
